import React from 'react';
import PropTypes from 'prop-types';

function Spinner({ fullPage = false }) {
  return (
    <div
      className={`${
        fullPage ? 'flex items-center justify-center h-screen' : 'flex items-center justify-center'
      } ${fullPage ? 'bg-white md:bg-[#F7F8FA]' : ''}`}
    >
      <div
        className={`animate-spin rounded-full ${
          fullPage ? 'h-20 w-20' : 'h-10 w-10'
        } border-t-4 border-b-4 border-blue-500`}
      />
    </div>
  );
}

Spinner.propTypes = {
  fullPage: PropTypes.bool,
};

export default Spinner;
